module.exports = __webpack_public_path__ + "media/images/start-40-102868082146305ae2b4d9cac6c39f7d.png";